function formatMessage(description, url, method) {
    const endpoint = url.split('/').slice(3).join('/');
    return `Error de servicio<br/>${method} /${endpoint}<br/>${description}`;
}

module.exports = {
    formatMessage
}
